// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteModel {
    static getAttributeTypeMap() {
        return SiteModel.attributeTypeMap;
    }
}
SiteModel.discriminator = undefined;
SiteModel.additionalProperties = false;
SiteModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    },
    {
        "name": "siteLicenses",
        "baseName": "siteLicenses",
        "type": ""
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": ""
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": ""
    },
    {
        "name": "procurementMethods",
        "baseName": "procurementMethods",
        "type": ""
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": ""
    },
    {
        "name": "siteRoleType",
        "baseName": "siteRoleType",
        "type": "RoleType"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "nickName",
        "baseName": "nickName",
        "type": "string"
    },
    {
        "name": "businessStartTime",
        "baseName": "businessStartTime",
        "type": "Date"
    },
    {
        "name": "businessEndTime",
        "baseName": "businessEndTime",
        "type": "Date"
    },
    {
        "name": "siteNote",
        "baseName": "siteNote",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "stateTaxId",
        "baseName": "stateTaxId",
        "type": "string"
    },
    {
        "name": "isSitePayable",
        "baseName": "isSitePayable",
        "type": "boolean"
    },
    {
        "name": "isActive",
        "baseName": "isActive",
        "type": "boolean"
    },
];
//# sourceMappingURL=siteModel.js.map